import { ApproveWalletCheckButton, PlateItemFooter } from "components";
import {
  QuoteEntity,
  CONTRACT_DIRECTION_ENUM,
  BID_REQUEST_STATUS_ENUM,
  RISK_STATUS_ENUM,
  QUOTE_STATUS_ENUM,
  OPERATION_TYPE,
} from "interfaces";
import { observer } from "mobx-react-lite";
import { ApproveDoubleVerificationBtn } from "pages/BidInfoPage/BidOperations/ApproveDoubleVerificationBtn";
import { useStores } from "stores";
import { isStatusIncluded } from "utils";

export const QuoteFooter = observer(({ item }: { item: QuoteEntity }): React.ReactNode | null => {
  const { quotes, user, bidCard } = useStores();

  const bidStatus = bidCard.bid.status;
  const isExpContract = bidCard.bid.contract.direction === CONTRACT_DIRECTION_ENUM.EXP;

  const isNewBid = isStatusIncluded(bidStatus, [BID_REQUEST_STATUS_ENUM.NEW]);
  const isQuoteExpired = isStatusIncluded(item.status, [QUOTE_STATUS_ENUM.EXPIRED]);
  const isQuoteCanceled = isStatusIncluded(item.status, [QUOTE_STATUS_ENUM.CANCELED]);
  const isQuoteRisky = isStatusIncluded(item.riskStatus ?? "", [RISK_STATUS_ENUM.APPROVE_NEEDED]);

  const isOtherUserQuote = item.userId !== user.userInfo?.id;

  const canApproveRisk =
    user.roles.isRiskManager && isQuoteRisky && !isQuoteExpired && !isQuoteCanceled && Boolean(item.checkId);

  const canApproveWalletVerification =
    user.roles.isProvider && isExpContract && isNewBid && !item.destinationWalletVerified && !isQuoteCanceled;

  if (!canApproveRisk && !canApproveWalletVerification && isOtherUserQuote) {
    return null;
  }

  const description = canApproveRisk
    ? "Требуется согласование. Эта котировка несёт высокий риск."
    : !isOtherUserQuote && canApproveWalletVerification
      ? "Требуется подтверждение другого пользователя"
      : canApproveWalletVerification
        ? "Требуется подтвердить данные котировки"
        : undefined;

  return (
    description && (
      <PlateItemFooter description={description}>
        {canApproveRisk && <ApproveWalletCheckButton checkId={item.checkId!} onSuccess={quotes.fetch} />}

        {canApproveWalletVerification && isOtherUserQuote && (
          <ApproveDoubleVerificationBtn
            btnTitle="Подтвердить"
            operationPath={OPERATION_TYPE.VERIFY_WALLET_QUOTE}
            walletAddress={item.destinationWallet}
            requestId={item.id}
            btnProps={{
              variant: "outlined",
              size: "small",
            }}
          />
        )}
      </PlateItemFooter>
    )
  );
});
